import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import type {
  SealingRecapQuery,
  SealingRecapQueryVariables,
} from './__generated__/index.withFetch.graphql.ts';
import { SealingRecap } from './index.tsx';

const query = gql`
  query SealingRecapQuery($slugs: [String!]!) {
    anyCards(slugs: $slugs) {
      slug
      ...SealingRecap_anyCard
    }
  }
  ${SealingRecap.fragments.anyCard}
` as TypedDocumentNode<SealingRecapQuery, SealingRecapQueryVariables>;

type Props = {
  rarity: Rarity;
  selectedCardsSlugs: string[];
  onClose: () => void;
};
export const SealingRecapWithFetch = ({
  rarity,
  selectedCardsSlugs,
  onClose,
}: Props) => {
  const { data } = useQuery(query, {
    variables: {
      slugs: selectedCardsSlugs,
    },
    skip: selectedCardsSlugs.length === 0,
  });

  const cards = data?.anyCards || [];

  return <SealingRecap rarity={rarity} cards={cards} onClose={onClose} />;
};
